import * as React from 'react';
import { Header1, InlineText1 } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { NBSP } from '../../constants/symbols';
import { RISKS } from '../../constants/risks';

import * as styles from './styles.css';

export const Risks: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['wrapper']}>
          <div className={styles['title']}>
            <Header1>
              <span>{`Какие могут быть риски при${NBSP}покупке жилья`}</span>
            </Header1>
          </div>
          <ul className={styles['tags']}>
            {RISKS.map((risk, index) => {
              return (
                <li key={index}>
                  <InlineText1>{risk}</InlineText1>
                </li>
              );
            })}
          </ul>
        </div>
      </Wrapper>
    </div>
  );
};

Risks.displayName = 'Risks';
